import { useLocation } from 'react-router';

export const useQueryParams = () => {
	const { search } = useLocation();
	const queryParams = new URLSearchParams(search);
	return { queryParams };
};
